<template>
  <el-tooltip v-if="visible" style="cursor: pointer">
    <div slot="content">
      {{ tooltip }}
    </div>
    <el-tag :type="type" size="small" @click="openTask">
      <i :class="icon" /> {{ label }}
    </el-tag>
  </el-tooltip>
</template>

<script>
import { TagStatus } from '../enum/TagStatusEnum'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'TagStatus',

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      TagStatus
    }
  },

  methods: {
    openTask() {
      if (this.model.runningTask) {
        this.$router.push(
          projectRoute({
            name: 'TaskHistoryView',
            query: { id: this.model.runningTask.id }
          })
        )
      }
    }
  },

  computed: {
    visible() {
      return this.model.status && this.model.status !== TagStatus.ACTIVE
    },

    icon() {
      if (!this.model.runningTask) {
        return 'el-icon-loading'
      } else if (this.model.runningTask.status < 2) {
        return 'el-icon-loading'
      } else {
        return 'el-icon-warning'
      }
    },

    type() {
      if (!this.model.runningTask) {
        return 'warning'
      } else if (this.model.runningTask.status < 2) {
        return 'warning'
      } else {
        return 'danger'
      }
    },

    isTaskFailed() {
      return this.model.runningTask && this.model.runningTask.status >= 2
    },

    label() {
      if (this.isTaskFailed) {
        return 'Error'
      }
      switch (this.model.status) {
        case TagStatus.ACTIVE:
          return null
        case TagStatus.CONVERTING:
          return 'Converting'
        default:
          return 'Unknown Status'
      }
    },

    tooltip() {
      if (!this.model.runningTask) {
        return this.runningTooltip
      } else if (this.model.runningTask.status < 2) {
        return this.runningTooltip
      } else {
        return this.failedTooltip
      }
    },

    runningTooltip() {
      switch (this.model.status) {
        case TagStatus.ACTIVE:
          return null
        case TagStatus.CONVERTING:
          return 'Attribute type is currently being converted. Click for more details'
        default:
          return null
      }
    },

    failedTooltip() {
      switch (this.model.status) {
        case TagStatus.ACTIVE:
          return null
        case TagStatus.CONVERTING:
          return 'Attribute type conversion failed. Click for more details'
        default:
          return null
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/data-manager/components/TagStatus.vue